<template>

  <loadingPage v-if="loading_visible"/>
  <router-view> </router-view>

  <Teleport to="body">
    <div class="recommend-toast-overlay" v-if="recommendToast.visible">
      <div class="recommend-toast">
        <div class="recommend-toast-header">
          <span>📋 오늘의 권장 할일</span>
          <button class="recommend-toast-close" @click="dismissRecommendToast">✕</button>
        </div>
        <ul class="recommend-toast-list">
          <li v-for="(item, i) in recommendToast.items" :key="i">
            <label>
              <input type="checkbox" v-model="item.checked" />
              <span>{{ item.title }}</span>
            </label>
          </li>
        </ul>
        <div class="recommend-toast-btns">
          <button @click="dismissRecommendToast">닫기</button>
          <button class="main" @click="acceptRecommendTodos">{{ recommendToast.items.filter(x=>x.checked).length }}개 할일에 추가</button>
        </div>
      </div>
    </div>
  </Teleport>

</template>



<script>
import { getCurrentInstance, provide, ref, reactive, onMounted } from "vue";
import axios from 'axios';
import loadingPage from '@/components/dialogs/loadingSlide.vue';

export default {
  components: { loadingPage },
  setup() {


    // App.vue setup() 안, provide 전에
    const kakaoJsKey = window.location.hostname === 'bodiary.com'
      ? '44b78bb182024ebe7b023b78fa129726'
      : '86a4094a537d9b6954cd5afc44babb86'

    if (window.Kakao && !window.Kakao.isInitialized()) {
      window.Kakao.init(kakaoJsKey)
    }

  onMounted(() => {

    // Promise 방식 지원 여부 체크
    function checkNotificationPromise() {
      try {
        Notification.requestPermission().then()
      } catch (e) {
        return false
      }
      return true
    }

    // 알림 권한 요청
    function requestNotificationPermission() {
      if (!("Notification" in window)) {
        console.log("이 브라우저는 알림을 지원하지 않습니다.")
        return
      }

      const handlePermission = (permission) => {
        // 구형 크롬 호환
        if (!("permission" in Notification)) {
          Notification.permission = permission
        }

        if (permission === "denied") {
          console.log("알림이 차단되어 있습니다.")
        }
      }

      // Promise 지원하면 Promise 방식, 아니면 콜백 방식
      if (checkNotificationPromise()) {
        Notification.requestPermission().then(handlePermission)
      } else {
        Notification.requestPermission(handlePermission)
      }
    }

    // 알림 보내기
    function showNotification(title, message, duration = 5000) {
      if (!("Notification" in window)) return
      if (Notification.permission !== "granted") return
      
      const notification = new Notification(title, {
        body: message,
        icon: '/imgs/LOGO.png'
      })
      
      notification.onclick = () => {
        window.focus()
        notification.close()
      }
      
      if (duration > 0) {
        setTimeout(() => notification.close(), duration)
      }
    }
    // showNotification('일정 알림', '오후 3시 고객 미팅', 10000)  // 10초
    provide("showNotification", showNotification);

    // 초기화
    requestNotificationPermission()

    const app = getCurrentInstance().appContext.app
    
    const logError = (errorType, message, stack, componentName = null) => {
      const msg = (message || '').replace(/'/g, "''").substring(0, 500)
      const stk = (stack || '').replace(/'/g, "''")
      const comp = componentName ? `'${componentName}'` : 'NULL'
      const mbId = member_info?.mb_id ? `'${member_info.mb_id}'` : 'NULL'
      
      sql_query(`
        INSERT INTO error_log 
        (error_type, message, stack, component_name, page_url, browser, screen_size, user_agent, mb_id)
        VALUES (
          '${errorType}',
          '${msg}',
          '${stk}',
          ${comp},
          '${window.location.pathname}',
          '${getBrowser()}',
          '${window.innerWidth}x${window.innerHeight}',
          '${navigator.userAgent.replace(/'/g, "''")}',
          ${mbId}
        )
      `).catch(e => console.error('에러 저장 실패:', e))
    }
    
    // Vue 에러 핸들러
    app.config.errorHandler = (err, instance) => {
      console.error('[Vue Error]', err)
      logError('vue', err.message, err.stack, instance?.$options?.name)
    }
    
    // window 에러
    window.addEventListener('error', (e) => {
      logError('window', e.message, e.error?.stack)
    })
    
    // Promise 에러
    window.addEventListener('unhandledrejection', (e) => {
      logError('promise', e.reason?.message || String(e.reason), e.reason?.stack)
    })
  })

    function getBrowser() {
      const ua = navigator.userAgent
      if (ua.includes('Chrome')) return 'Chrome'
      if (ua.includes('Firefox')) return 'Firefox'
      if (ua.includes('Safari')) return 'Safari'
      if (ua.includes('Edge')) return 'Edge'
      return 'Other'
    }

    /** THEME SETUP */
    onMounted(() => {
      const savedTheme = localStorage.getItem('theme') || 'system';
      const root = document.documentElement;
      
      root.classList.remove('light-mode', 'dark-mode');
      
      if (savedTheme === 'light') {
        root.classList.add('light-mode');
      } else if (savedTheme === 'dark') {
        root.classList.add('dark-mode');
      }
    });

    /** LOADING PROVIDE */
    const loading_visible = ref(false);
    function showLoading(b) { loading_visible.value = b }
    provide('showLoading', showLoading);


    /** SQL PROVIDE */
    function sql_query(sql) {
      return axios
        .post('/api/query', { query: sql })
        .then(r => r.data)
        .catch(err => {
          console.warn('❌ 쿼리 실행 실패:', err, sql);
          return err.response?.data || err.message;
        });
    }
    provide('sql_query', sql_query);


    /** JWT PROVIDE */
    const readToken = () => localStorage.getItem('auth_token') || null;
    function decodeJWT(t) {
      if (!t) return null;
      const parts = t.split('.');
      if (parts.length < 2) return null;
      try {
        let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        b64 += '='.repeat((4 - (b64.length % 4)) % 4);
        return JSON.parse(atob(b64));
      } catch { return null; }
    }
    const getPayload = () => decodeJWT(readToken());
    function getMbid() { return getPayload()?.mb_id ?? null; }
    function isLoggedIn() {
      const p = getPayload();
      return !!p && typeof p.exp === 'number' && p.exp > Date.now() / 1000;
    }
    function logout() {
      localStorage.removeItem('auth_token');
      
      // 그누보드도 로그아웃
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = 'https://amadiary.com/bbs/logout.php';
      document.body.appendChild(iframe);
      
      setTimeout(() => {
        document.body.removeChild(iframe);
        location.replace('/login');
      }, 1000);
    }
    provide('getMbid', getMbid);
    provide('isLoggedIn', isLoggedIn);
    provide('logout', logout);


    /** LOGIN PROVIDE */
    function login_test(mb_id, mb_pw) {
      return axios
        .post('/api/login', { mb_id, mb_pw })
        .then(response => {
          localStorage.setItem('auth_token', response.data.token);
          return response.data;
        })
        .catch(error => {
          console.warn('❌ 로그인 실패:', error);
          return error.response?.data || error.message;
        });
    }
    provide("login_test", login_test);
    
    // 로그인 없이 접근 가능한 경로
    const PUBLIC_PATHS = ['/login', '/intro', '/event', '/gift', '/roulette', '/terms', '/design-request'];

    if (!isLoggedIn()) {
      const isPublic = PUBLIC_PATHS.some(p => location.pathname.startsWith(p) || location.pathname.includes(p));
      if (!isPublic) location.replace('/intro/main');
    } else if (location.pathname === '/login') {
      location.replace('/');
    }


    /** PROFILE  */
    const basic_profile_url = `/imgs/unknow_user.png`;
    const member_info = reactive({
      mb_id: getMbid(),
      nickname: null,
      name: "이름 없음",
      introduce: "소개 없음",
      image: basic_profile_url,
      level: 0,
    });


    /** GET USER INFO PROFILE PROVIDE */
    async function getUserProfileInfo(mb_id) {
      const id = mb_id || getMbid();
      if (!id) {
        console.warn("❌ mb_id가 없습니다. 로그인이 필요합니다.");
        return null;
      }

      const query = `
        SELECT 
          mb_id, name, nickname, introduce, image, level, point, phone, email
        FROM member
        WHERE mb_id = '${id}'
      `;

      try {
        const rows = await sql_query(query);
        if (!rows?.length) return null;

        const m = rows[0];
        return {
          mb_id: m.mb_id,
          name: m.name || "이름 없음",
          nickname: m.nickname || "닉네임 없음",
          introduce: m.introduce || "소개 없음",
          image: m.image || basic_profile_url,
          level: m.level || 0,
          point: m.point || 0,
          phone: m.phone || "전화번호 없음",
          email: m.email || "이메일 없음",
        };
      } catch (err) {
        console.warn("❌ 프로필 로드 실패:", err);
        return null;
      }
    }
    // first load profile
    getUserProfileInfo().then(info => {
      if (info) {
        Object.assign(member_info, info);
      }
    });
    // 프로필 수정 이벤트 리스너
    window.addEventListener('profile-updated', (e) => {
      const d = e.detail;
      if (d.nickname) member_info.nickname = d.nickname;
      if (d.introduce) member_info.introduce = d.introduce;
      if (d.phone) member_info.phone = d.phone;
      if (d.image) member_info.image = d.image;
    });
    provide("member_info", member_info);
    provide("getUserProfileInfo", getUserProfileInfo);


    /** CHECK MB BASIC INFO */
    function checkMemberBasicInfo() {
      const p = getPayload();
      if (!p?.mb_id) return;
      const q = `SELECT * FROM member WHERE mb_id='${p.mb_id}'`;
      sql_query(q).then(rows => {
        if (Array.isArray(rows) && rows.length > 0) {
          const m = rows[0];
          if (!m.name || !m.phone || !m.nickname) {
            if (location.pathname !== "/register") location.replace("/register");
          }
        }
      }).catch(() => {});
    }
    checkMemberBasicInfo();

    /** 아침 Toast 할일 알림 & 알람 체크 (기존 todos 테이블 기반) */
    async function fetchMorningTasks() {
      const mbId = getMbid();
      if (!mbId) return;

      const toastKey = `todo_toast_${mbId}_${new Date().toISOString().slice(0,10)}`;
      if (localStorage.getItem(toastKey)) return;

      try {
        const now = new Date();
        const todayStr = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;

        // 오늘 할일 중 미완료
        let rows = await sql_query(`
          SELECT title FROM todos
          WHERE mb_id='${mbId}' AND is_completed=0
            AND DATE(due_date)='${todayStr}'
          ORDER BY priority ASC
          LIMIT 3
        `);

        // 할일이 없으면 daily_task_template에서 권장 할일 조회
        if (!Array.isArray(rows) || !rows.length) {
          const grp = await sql_query(`SELECT main_group_idx, group_node_idx, role_idx FROM group_member WHERE mb_id='${mbId}' AND status='join' LIMIT 1`);
          if (grp?.[0]) {
            const { main_group_idx, group_node_idx, role_idx } = grp[0];
            const dow = now.getDay();
            const dom = now.getDate();
            rows = await sql_query(`
              SELECT title FROM daily_task_template
              WHERE main_group_idx='${main_group_idx}' AND is_active=1
                AND (recurrence_type='daily' OR (recurrence_type='weekly' AND day_of_week=${dow}) OR (recurrence_type='monthly' AND day_of_month=${dom}))
                AND (target_group_node_idx IS NULL OR target_group_node_idx='${group_node_idx}')
                AND (target_role_idx IS NULL OR target_role_idx='${role_idx}')
              ORDER BY sort_order ASC, priority ASC
              LIMIT 3
            `);
          }
        }
        if (!Array.isArray(rows) || !rows.length) return;

        const taskText = rows.map((r, i) => `${i+1}. ${r.title}`).join('\n');
        if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          new Notification('📋 오늘의 할일', { body: taskText, icon: '/imgs/LOGO.png' });
        }
        localStorage.setItem(toastKey, '1');
      } catch(e) { console.warn('아침 할일 로드 실패:', e); }
    }

    async function checkTodoAlarms() {
      const mbId = getMbid();
      if (!mbId) return;
      try {
        const now = new Date();
        const nowStr = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
        const rows = await sql_query(`
          SELECT idx, title FROM todos
          WHERE mb_id='${mbId}' AND alarm_at IS NOT NULL
            AND alarm_at <= '${nowStr}' AND alarm_sent=0 AND is_completed=0
          LIMIT 5
        `);
        if (!Array.isArray(rows) || !rows.length) return;
        for (const todo of rows) {
          if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
            new Notification('📅 할일 알림', { body: todo.title, icon: '/imgs/LOGO.png' });
          }
          await sql_query(`UPDATE todos SET alarm_sent=1 WHERE idx=${todo.idx}`);
        }
      } catch(e) { console.warn('알람 체크 실패:', e); }
    }

    async function checkEveningReminder() {
      const mbId = getMbid();
      if (!mbId) return;
      const now = new Date();
      if (now.getHours() < 17) return;

      const eveningKey = `todo_evening_${mbId}_${now.toISOString().slice(0,10)}`;
      if (localStorage.getItem(eveningKey)) return;

      try {
        const todayStr = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
        const rows = await sql_query(`
          SELECT title FROM todos
          WHERE mb_id='${mbId}' AND is_completed=0
            AND DATE(due_date)='${todayStr}'
          ORDER BY priority ASC LIMIT 5
        `);
        if (!Array.isArray(rows) || !rows.length) return;

        const taskText = rows.map((r, i) => `${i+1}. ${r.title}`).join('\n');
        if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          new Notification('⏰ 오늘 할일 완료하셨나요?', { body: taskText + '\n\n아직 미완료 할일이 있습니다!', icon: '/imgs/LOGO.png' });
        }
        localStorage.setItem(eveningKey, '1');
      } catch(e) { console.warn('저녁 리마인더 실패:', e); }
    }

    const recommendToast = reactive({ visible: false, items: [] });

    async function checkRecommendedTasks() {
      const mbId = getMbid();
      if (!mbId) return;
      const now = new Date();
      const h = now.getHours();
      if (h < 10 || h >= 12) return;

      const recKey = `todo_recommend_${mbId}_${now.toISOString().slice(0,10)}`;
      if (localStorage.getItem(recKey)) return;

      try {
        const grp = await sql_query(`SELECT main_group_idx, group_node_idx, role_idx FROM group_member WHERE mb_id='${mbId}' AND status='join' LIMIT 1`);
        if (!grp?.[0]) return;
        const { main_group_idx, group_node_idx, role_idx } = grp[0];
        const dow = now.getDay();
        const dom = now.getDate();
        const rows = await sql_query(`
          SELECT idx, title, description, priority FROM daily_task_template
          WHERE main_group_idx='${main_group_idx}' AND is_active=1
            AND (recurrence_type='daily' OR (recurrence_type='weekly' AND day_of_week=${dow}) OR (recurrence_type='monthly' AND day_of_month=${dom}))
            AND (target_group_node_idx IS NULL OR target_group_node_idx='${group_node_idx}')
            AND (target_role_idx IS NULL OR target_role_idx='${role_idx}')
          ORDER BY sort_order ASC, priority ASC
          LIMIT 10
        `);
        if (!Array.isArray(rows) || !rows.length) return;

        recommendToast.items = rows.map(r => ({ ...r, checked: true }));
        recommendToast.visible = true;
      } catch(e) { console.warn('권장할일 조회 실패:', e); }
    }

    function dismissRecommendToast() {
      recommendToast.visible = false;
      const mbId = getMbid();
      if (mbId) localStorage.setItem(`todo_recommend_${mbId}_${new Date().toISOString().slice(0,10)}`, '1');
    }

    async function acceptRecommendTodos() {
      const mbId = getMbid();
      if (!mbId) return;
      const checked = recommendToast.items.filter(x => x.checked);
      if (!checked.length) { dismissRecommendToast(); return; }

      const now = new Date();
      const todayStr = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} 00:00:00`;
      for (const item of checked) {
        const escTitle = item.title.replace(/'/g, "''");
        await sql_query(`
          INSERT INTO todos (mb_id, title, is_completed, due_date, priority, source_type, activity_score, created_at, updated_at)
          VALUES ('${mbId}', '${escTitle}', 0, '${todayStr}', ${item.priority ?? 1}, 'template', ${item.activity_score || 0}, NOW(), NOW())
        `);
      }
      dismissRecommendToast();
      window.dispatchEvent(new Event('todos-updated'));
    }

    if (isLoggedIn()) {
      setTimeout(fetchMorningTasks, 3000);
      setInterval(checkTodoAlarms, 60000);
      setTimeout(checkTodoAlarms, 5000);
      setInterval(checkEveningReminder, 60000);
      setTimeout(checkEveningReminder, 8000);
      setTimeout(checkRecommendedTasks, 10000);
    }

    /** AUTO LOGOUT - 주기적 체크 */
    function checkTokenExpiry() {
      const p = getPayload();
      if (p && typeof p.exp === 'number' && p.exp < Date.now() / 1000) {
        logout();
      }
    }
    checkTokenExpiry();
    setInterval(checkTokenExpiry, 60 * 1000);

    /** AXIOS INTERCEPTOR - 401 응답 시 로그아웃 */
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          logout();
        }
        return Promise.reject(error);
      }
    );


    /** UP CHECK API */
    function IP_check(name, id) {
      return axios
        .post('https://dataapi.co.kr/scrap/common/ecleanins/FinancialConsultantInquiry', {
          DSNM: name, ESTATENUM: id
        })
        .then(r => r.data?.result === 'SUCCESS' ? r.data.data : Promise.reject(r.data?.errMsg || '조회 실패'))
        .catch(e => {
          console.warn('❌ 설계사 조회 실패:', e);
          return e.response?.data || e.message;
        });
    }
    provide("IP_check", IP_check);


    /** AMA API */
    function getAmaStorys() {
      return axios
        .post('/api/ama/getPosts', { mb_id: getMbid() })
        .then(r => r.data)
        .catch(e => e.response?.data || e.message);
    }
    provide("getAmaStorys", getAmaStorys);


    /** SMS API*/
    function SMS_sendAuthCode(receiver_phone) {
      return axios.post('/api/solapi/sendAuthCode', { receiver_phone })
        .then(r => r.data)
        .catch(e => e.response?.data || e.message);
    }
    function SMS_verifyAuthCode(receiver_phone, verify_code) {
      return axios.post('/api/solapi/verifyAuthCode', { receiver_phone, verify_code })
        .then(r => r.data)
        .catch(e => e.response?.data || e.message);
    }
    // 메시지 전송
    function SMS_send(to, text, from = null) {
      return axios.post('/api/solapi/send', { to, text, from })
        .then(r => r.data)
        .catch(e => e.response?.data || e.message);
    }
    // 대량 전송 (동일 메시지)
    function SMS_sendBulk(receivers, text, from = null) {
      return axios.post('/api/solapi/sendBulk', { receivers, text, from })
        .then(r => r.data)
        .catch(e => e.response?.data || e.message);
    }
    // 개별 전송 (각각 다른 메시지)
    function SMS_sendMultiple(messages, from = null) {
      return axios.post('/api/solapi/sendMultiple', { messages, from })
        .then(r => r.data)
        .catch(e => e.response?.data || e.message);
    }
    // 예약 전송
    function SMS_sendScheduled(to, text, scheduledDate, from = null) {
      return axios.post('/api/solapi/sendScheduled', { to, text, scheduledDate, from })
        .then(r => r.data)
        .catch(e => e.response?.data || e.message);
    }

    provide("SMS_sendAuthCode", SMS_sendAuthCode);
    provide("SMS_verifyAuthCode", SMS_verifyAuthCode);
    provide("SMS_send", SMS_send);
    provide("SMS_sendBulk", SMS_sendBulk);
    provide("SMS_sendMultiple", SMS_sendMultiple);
    provide("SMS_sendScheduled", SMS_sendScheduled);

    /** BOARD API */
    function updatePost(idx, title, table, content, thumb, category_id) {
      return axios
        .post('/api/board/post', { idx, mb_id: getMbid(), table, title, content, thumb })
        .then(r => {
          const upd = `UPDATE ${table} SET category_id='${category_id}', is_temp='0' WHERE idx=${idx}`;
          sql_query(upd);
          return r.data;
        })
        .catch(e => e.response?.data || e.message);
    }
    provide("updatePost", updatePost);

    const board_viewing = reactive({ idx: null });
    const board_editing = reactive({ idx: null });
    provide('board_viewing', board_viewing);
    provide('board_editing', board_editing);


    /** INSU PROVIDE */
    const insuCompanys = ref([]);
    const insuCompanyClaimList = ref([]);
    provide("insuCompanys", insuCompanys);

    async function getInsuCompanys() {
      try {
        const rows = await sql_query(`SELECT * FROM insu_company ORDER BY sort_no ASC`);
        if (Array.isArray(rows)) {
          insuCompanys.value = rows.map(r => ({
            idx: r.idx,
            no: r.sort_no, name: r.name, type: r.type, old_name: r.old_name,
            value: r.code, system_url: r.system_url, phone: r.phone,
            short_img: r.short_img, long_img: r.long_img
          }));
        }
      } catch (e) { console.warn('❌ 보험사 정보 조회 실패:', e); }
    }
    getInsuCompanys();


    /** INSU API */
    async function getInsuCompanyClaim() {
      try {
        const rows = await sql_query(`SELECT * FROM insu_company_claim ORDER BY idx DESC`);
        if (Array.isArray(rows)) {
          insuCompanyClaimList.value = rows.map(r => ({
            idx: r.idx, company_code: r.company_code, label: r.label, value: r.value
          }));
        }
      } catch (e) { console.warn('❌ 보험사 보상 접수처 정보 조회 실패:', e); }
    }
    getInsuCompanyClaim();
    provide("getInsuCompanyClaim", getInsuCompanyClaim);


    /** INSU PROVIDE */
    function getInsuCompanyClaimInfo(comp_id) {
      const matches = insuCompanyClaimList.value.filter(c => c.company_code === comp_id);
      return matches.length ? matches : null;
    }
    provide("getInsuCompanyClaimInfo", getInsuCompanyClaimInfo);

    function getInsuCompanyInfo(comp_id) {
      return insuCompanys.value.find(c => c.value === comp_id) ?? {
        name: "증권 없음", type: "", value: "",
        short_img: "https://png.pngtree.com/png-vector/20221125/ourmid/pngtree-no-image-available-icon-flatvector-illustration-picture-coming-creative-vector-png-image_40968940.jpg",
        long_img: ""
      };
    }
    provide('getInsuCompanyInfo', getInsuCompanyInfo);


    /** GET DISEASE INFO */
    async function getDiseaseInfo(icdCode, name) {
      let return_list = [];
      let cleanString = icdCode.replace(/\./g, '');

      let serviceKey = 'Gv%2FIDlZ3yOBKfM36IBQ6EFjbqU7pEf8dcvkGeyezoclQyPx9waKt5wrj%2F3kS4q%2BK5ZC3s9MaHRSTB3bvisFKbQ%3D%3D'; // 인증키
      let numOfRows = 10;  // 한 페이지 결과 수
      let pageNo = 1; // 페이지 번호
      let medTp = 1; // 양방, 한방 구분(1: 양방, 2: 한방)
      let sickType = cleanString.length >= 4 ? 2 : 1; // 상병 구분 (1: 3단 상병, 2: 4단 상병)

      let diseaseType = 'SICK_CD'; // 질병 검색 타입 (SICK_CD: 질병코드, SICK_NM: 질병명)
      let searchText = cleanString; // 검색어를 ICD 코드에서 추출 (예: J00.0 -> "J00")

      let length = cleanString.length;
      if (length >= 4) {
        sickType = '2';
      }

      if (name) {
        diseaseType = 'SICK_NM'; // 질병 검색 타입 (SICK_CD: 질병코드, SICK_NM: 질병명)
        searchText = name; // 검색어를 ICD 코드에서 추출 (예: J00.0 -> "J00")
      }

      let url = 'https://apis.data.go.kr/B551182/diseaseInfoService1/getDissNameCodeList1?serviceKey='+serviceKey+'&numOfRows='+numOfRows+'&pageNo='+pageNo+'&sickType='+sickType+'&medTp='+medTp+'&diseaseType='+diseaseType+'&searchText='+searchText+'';

      await axios.get(url)
        .then(response => {
          let data = response.data;

          if (data?.response?.body?.items?.item?.length === undefined && data?.response?.body?.items?.item !== undefined) {
            // 1개 처리
            return_list.push(data?.response?.body?.items?.item);
          } else {
            // 복수 또는 없음
            return_list = data?.response?.body?.items?.item;
          }
        })
        .catch(error => {
          console.error(error);
          return_list = [];
        });
      return return_list;
    }
    provide('getDiseaseInfo', getDiseaseInfo);


    /** UTILS */
    function calculateAge(ymd) {
      const today = new Date(), birth = new Date(ymd);
      let age = today.getFullYear() - birth.getFullYear();
      const m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
      return age;
    }
    
    function calculateInsuAge(birthYmd) {
      let y, m, d;

      // 6자리 → YYMMDD
      if (/^\d{6}$/.test(birthYmd)) {
        const yy = parseInt(birthYmd.substring(0, 2), 10);
        y = yy >= 30 ? 1900 + yy : 2000 + yy; // 1930~ 기준으로 세대 판단 (필요하면 조정)
        m = parseInt(birthYmd.substring(2, 4), 10) - 1;
        d = parseInt(birthYmd.substring(4, 6), 10);

      // 8자리 → YYYYMMDD
      } else if (/^\d{8}$/.test(birthYmd)) {
        y = parseInt(birthYmd.substring(0, 4), 10);
        m = parseInt(birthYmd.substring(4, 6), 10) - 1;
        d = parseInt(birthYmd.substring(6, 8), 10);

      } else {
        return "00"; // 형식 오류
      }

      const today = new Date();
      const birth = new Date(y, m, d);

      let age = today.getFullYear() - birth.getFullYear();

      // 보험나이 rule: 생일 + 6개월 전까지는 아직 한 살 전
      const six = new Date(birth);
      six.setMonth(six.getMonth() + 6);
      six.setFullYear(today.getFullYear());

      if (today < six) age--;

      return String(age).padStart(2, "0");
    }


    provide("calculateAge", calculateAge);
    provide("calculateInsuAge", calculateInsuAge);


    /** notification */
    function sendNotification(title, mb_id, sender, message, type) {
      const q = `INSERT INTO notification set mb_id='${mb_id}', sender='${sender}', title='${title}', message='${message}', type='${type}'`;
      sql_query(q);
    }
    provide("sendNotification", sendNotification);

    /** PHONE REGEX */
    function formatKRPhone(v) {
      const d = String(v).replace(/\D/g, '');
      const L = d.length;
      if (!L) return '';

      // 02 (서울)
      if (d.startsWith('02')) {
        if (L <= 2) return d;
        if (L <= 5) return d.slice(0,2) + '-' + d.slice(2);
        if (L <= 9)  return d.slice(0,2) + '-' + d.slice(2,5) + '-' + d.slice(5,9);
        return d.slice(0,2) + '-' + d.slice(2,6) + '-' + d.slice(6,10);
      }

      // 대표/안내번호 15xx/16xx/18xx
      if (/^1[568]\d{2}/.test(d)) {
        if (L <= 4) return d;
        return d.slice(0,4) + '-' + d.slice(4,8);
      }

      // 일반 3자리 국번 (010, 070, 0[3-6]X 등)
      if (L <= 3) return d;
      if (L <= 7) return d.slice(0,3) + '-' + d.slice(3,7);
      // 10자리면 3-3-4, 11자리면 3-4-4
      if (L === 10) return d.slice(0,3) + '-' + d.slice(3,6) + '-' + d.slice(6,10);
      return d.slice(0,3) + '-' + d.slice(3,7) + '-' + d.slice(7,11);
    }
    provide("formatKRPhone", formatKRPhone);

    /* 출첵 오늘 정보 가져오기 - 단순: 오늘 기록만 */
    async function attened_getToday(userId) {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const today = `${year}-${month}-${day}`;

      const result = await sql_query(
        `SELECT * FROM attendance WHERE mb_id = '${userId}' AND work_date = '${today}' AND type = 'normal'`
      );
      
      // sql_query가 에러 시 null을 반환한다면 명시적으로 체크
      if (result === null || result === false) {
        throw new Error('DB 조회 실패');
      }
      
      return result;
    }
    provide("attened_getToday", attened_getToday);

    /* 출근 하기 - 로컬(KST) 기준 */
    async function attend_checkIn(userId) {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const mins = String(now.getMinutes()).padStart(2, '0');
      const secs = String(now.getSeconds()).padStart(2, '0');
      
      const workDate = `${year}-${month}-${day}`;
      const checkIn = `${year}-${month}-${day} ${hours}:${mins}:${secs}`;
      
      window.localStorage.setItem("todayCheckIn", checkIn);
      // 구조화된 캐시 (AttendanceToast 오프라인 방어용)
      try {
        window.localStorage.setItem("attendance_today", JSON.stringify({
          date: workDate, mb_id: userId,
          check_in: checkIn, check_out: null,
          timestamp: Date.now()
        }));
      } catch(e) { /* 무시 */ }

      let sql = `
        INSERT INTO attendance SET
        mb_id = '${userId}',
        work_date = '${workDate}',
        check_in = '${checkIn}',
        type = 'normal',
        status = 1
        ON DUPLICATE KEY UPDATE
          check_in = '${checkIn}'
      `;
      await sql_query(sql);

      // 출근 활동점수 5점 적립 (하루 1회)
      const scoreKey = `attend_score_${userId}_${workDate}`;
      if (!localStorage.getItem(scoreKey)) {
        await sql_query(`INSERT INTO activity_score_log (mb_id, score, source_type, reason, created_at) VALUES ('${userId}', 5, 'manual', '출근 체크인', NOW())`);
        localStorage.setItem(scoreKey, '1');
      }
    }
    provide("attend_checkIn", attend_checkIn);

    /* 퇴근 하기 - 단순: 오늘 기록만 */
    async function attend_checkOut(userId) {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');
      
      const today = `${year}-${month}-${day}`;
      const checkOut = `${year}-${month}-${day} ${h}:${m}:${s}`;
      
      await sql_query(`
        UPDATE attendance 
        SET check_out = '${checkOut}' 
        WHERE mb_id = '${userId}' 
          AND work_date = '${today}' 
          AND type = 'normal'
          AND check_in IS NOT NULL
          AND check_out IS NULL
      `);
      window.localStorage.setItem("todayCheckOut", checkOut);
      // 구조화된 캐시 업데이트 (AttendanceToast 오프라인 방어용)
      try {
        const raw = window.localStorage.getItem("attendance_today");
        const cache = raw ? JSON.parse(raw) : {};
        window.localStorage.setItem("attendance_today", JSON.stringify({
          ...cache, date: today, mb_id: userId,
          check_out: checkOut, timestamp: Date.now()
        }));
      } catch(e) { /* 무시 */ }
    }
    provide("attend_checkOut", attend_checkOut);

    /* 출첵 업뎃 */
    async function attend_updateType(attendance_idx, type) {
      let sql = `
        UPDATE attendance
        SET type = '${type}'
        WHERE idx = '${attendance_idx}'
      `;
      await sql_query(sql);
    }
    provide("attend_updateType", attend_updateType);

    /* 비즈샵 */
    async function getGiftishowGoods(page = 3, size = 20) {
      const { data } = await axios.post('/api/giftishow/goods', { page, size })
      return data
    }
    provide('getGiftishowGoods', getGiftishowGoods)

    // 기존 fetch 방식 → axios로 변경
    async function purchaseGifticon(data) {
      console.log('🎁 구매 요청 데이터:', data);  // 디버깅
      
      try {
        const { data: result } = await axios.post('/api/giftishow/purchase', data);
        console.log('🎁 구매 응답:', result);  // 디버깅
        return result;
      } catch (e) {
        console.error('❌ 구매 실패:', e.response?.data || e.message);
        return e.response?.data || { success: false, message: e.message };
      }
    }
    provide('purchaseGifticon', purchaseGifticon);

    async function getGiftShowGoodsDetail(goodsCode) {
      try {
        const { data } = await axios.post('/api/giftishow/goods/detail', {
          goods_code: goodsCode
        });
        
        if (data.code === '0000') {
          return data.result;
        } else {
          console.error('상품 조회 실패:', data.message);
          return null;
        }
      } catch (error) {
        console.error('API 호출 실패:', error.message);
        return null;
      }
    }
    provide('getGiftShowGoodsDetail', getGiftShowGoodsDetail)

    // App.vue에서
    provide('getStreakDays', async () => 5);  // 테스트용 5일
    provide('getWeekAttendance', async () => [true, true, true, true, false, false, false]);
    // getMonthAttendance - 이번 달 출석한 날짜 배열 반환
    async function getMonthAttendance(mb_id) {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1; // 1-12
      
      // 이번 달 시작/끝
      const startDate = `${year}-${String(month).padStart(2, '0')}-01`;
      const endDate = `${year}-${String(month).padStart(2, '0')}-31`;
      
      const result = await sql_query(`
        SELECT DAY(work_date) as day
        FROM attendance
        WHERE mb_id = '${mb_id}'
          AND work_date BETWEEN '${startDate}' AND '${endDate}'
          AND check_in IS NOT NULL
        ORDER BY work_date`);
      
      console.log('getMonthAttendance result:', result); // 디버깅용
      
      // result 형태에 따라 처리
      const rows = Array.isArray(result) ? result : (result?.rows || result?.data || []);
      
      return rows.map(row => row.day);
    }
    provide('getMonthAttendance', getMonthAttendance);


    // 포인트 적립/차감
    async function addPoint(mb_id, type, amount, reason, reason_detail = '', reference_id = '') {
      // 현재 포인트 조회
      // addPoint(mb_id, 'spend', -3000, 'gifticon', '아이스아메리카노', 'BODA_20260202_xxx');
      const rows = await sql_query(`SELECT point FROM member WHERE mb_id = '${mb_id}'`);
      const current = rows?.[0]?.point || 0;
      const balanceAfter = current + amount;

      // 트랜잭션 기록
      await sql_query(`
        INSERT INTO point_transactions 
        SET mb_id = '${mb_id}',
            type = '${type}',
            amount = ${amount},
            balance_after = ${balanceAfter},
            reason = '${reason}',
            reason_detail = '${reason_detail}',
            reference_id = '${reference_id}'
      `);

      // member 포인트 업데이트
      await sql_query(`UPDATE member SET point = ${balanceAfter} WHERE mb_id = '${mb_id}'`);
      
      return balanceAfter;
    }
    provide('addPoint', addPoint);


    const CHANNEL_PUBLIC_ID = '_DUlyn'
    const isChannelFollowed = ref(localStorage.getItem('kakao_channel_followed') === 'true')

    function followKakaoChannel() {
      if (!window.Kakao?.Channel) return
      window.Kakao.Channel.followChannel({ channelPublicId: CHANNEL_PUBLIC_ID })
        .then(() => {
          isChannelFollowed.value = true
          localStorage.setItem('kakao_channel_followed', 'true')
        })
        .catch((err) => {
          console.error('채널 추가 에러', err)
        })
    }

    function chatKakaoChannel() {
      if (!window.Kakao?.Channel) return
      window.Kakao.Channel.chat({ channelPublicId: CHANNEL_PUBLIC_ID })
    }

    // 로그인된 유저 + 미가입자만 자동 팝업
    if (isLoggedIn() && !isChannelFollowed.value) {
      // SDK 로드 후 실행되도록 약간 딜레이
      setTimeout(() => {
        followKakaoChannel()
      }, 2000)
    }

    provide('isChannelFollowed', isChannelFollowed)
    provide('followKakaoChannel', followKakaoChannel)
    provide('chatKakaoChannel', chatKakaoChannel)

    // ===== BMS_FREE 테스트 발송 =====
    async function sendBmsFree(to, type = 'TEXT', options = {}) {
      try {
        const { data } = await axios.post('/api/test/bms-free', {
          to: to.replace(/-/g, ''),
          type,
          text: options.text || undefined,
          imageId: options.imageId || undefined,
          imageIds: options.imageIds || undefined,
          videoUrl: options.videoUrl || undefined,
          coupon: options.coupon || undefined
        })
        console.log('✅ [BMS_FREE]', type, data)
        return data
      } catch (e) {
        console.error('❌ [BMS_FREE]', e.response?.data || e.message)
        return e.response?.data || { success: false, message: e.message }
      }
    }
    provide('sendBmsFree', sendBmsFree)

    /** CUSTOMER MILESTONE */
    const customerMilestones = [10, 30, 50, 100, 200, 500];
    async function checkCustomerMilestone(mb_id) {
      if (!mb_id) return;
      try {
        const rows = await sql_query(`SELECT COUNT(*) as cnt FROM customers WHERE mb_id = '${mb_id}'`);
        const cnt = rows?.[0]?.cnt || 0;
        if (customerMilestones.includes(cnt)) {
          sendNotification(
            `🎉 고객 ${cnt}명 달성!`,
            mb_id,
            'system',
            `축하합니다! 고객 ${cnt}명을 등록하셨습니다.`,
            'milestone'
          );
          addPoint(mb_id, 'earn', cnt * 10, 'milestone', `고객 ${cnt}명 달성`);
        }
      } catch (e) {
        console.warn('마일스톤 체크 실패:', e);
      }
    }
    provide('checkCustomerMilestone', checkCustomerMilestone);

    /** ===== KG이니시스 직접 결제 (구독 + 토큰 공통) ===== */
    const PAYMENT_BASE_URL = window.location.origin

    async function requestInicisPayment({ oid, amount, goodname, buyername, buyertel, buyeremail, merchantData }) {
      let prep
      try {
        const res = await axios.post('/api/payment/inicis/prepare', { oid, price: amount })
        prep = res.data
      } catch (e) {
        return { success: false, message: e.message || '결제 준비 실패' }
      }
      return new Promise((resolve) => {
        try {
          const w = 520, h = 700
          const left = Math.round((screen.width - w) / 2)
          const top = Math.round((screen.height - h) / 2)
          const popup = window.open('about:blank', 'inicisPayment', `width=${w},height=${h},left=${left},top=${top},scrollbars=yes`)
          if (!popup) {
            resolve({ success: false, message: '팝업이 차단되었습니다. 팝업을 허용해주세요.' })
            return
          }
          popup.document.write('<html><head><title>결제</title></head><body style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;background:#f5f5f5"><p style="font-size:18px;color:#333">결제 준비 중...</p></body></html>')

          const form = document.createElement('form')
          form.method = 'post'
          form.acceptCharset = 'UTF-8'
          form.target = 'inicisPayment'
          form.action = 'https://stdpay.inicis.com/stdpay/INIStdPay.php'
          form.style.display = 'none'
          const fields = {
            version: '1.0', gopaymethod: 'Card', mid: prep.mid, oid, price: amount,
            timestamp: prep.timestamp, signature: prep.signature, mKey: prep.mKey,
            currency: 'WON', goodname,
            buyername: buyername || '고객',
            buyertel: (buyertel || '').replace(/-/g, ''),
            buyeremail: buyeremail || '',
            returnUrl: `${PAYMENT_BASE_URL}/api/payment/inicis/return`,
            closeUrl: `${PAYMENT_BASE_URL}/api/payment/inicis/close`,
            acceptmethod: 'below1000',
            merchantData: JSON.stringify(merchantData)
          }
          for (const [k, v] of Object.entries(fields)) {
            const inp = document.createElement('input')
            inp.type = 'hidden'
            inp.name = k
            inp.value = v
            form.appendChild(inp)
          }
          document.body.appendChild(form)
          form.submit()
          form.remove()

          let timeout, chk
          const cleanup = () => { clearTimeout(timeout); clearInterval(chk); window.removeEventListener('message', handler) }
          const handler = function(e) {
            if (e.data && e.data.type === 'INICIS_RESULT') { cleanup(); resolve(e.data) }
            else if (e.data && e.data.type === 'INICIS_CLOSE') { cleanup(); if (!popup.closed) popup.close(); resolve({ success: false, message: '결제가 취소되었습니다.' }) }
          }
          timeout = setTimeout(() => { cleanup(); if (!popup.closed) popup.close(); resolve({ success: false, message: '결제 시간 초과' }) }, 300000)
          chk = setInterval(() => { if (popup.closed) { cleanup(); resolve({ success: false, message: '결제가 취소되었습니다.' }) } }, 500)
          window.addEventListener('message', handler)
        } catch (e) {
          resolve({ success: false, message: e.message || '결제 처리 실패' })
        }
      })
    }

    // 구독 결제 (이니시스 단건결제 → 서버에서 구독 DB 생성)
    async function requestBillingKey({ planId, planName, price, interval, customerName, customerEmail, customerPhone }) {
      const mbId = getMbid()
      if (!mbId) return { success: false, message: '로그인 필요' }
      if (price <= 0) return { success: true }
      const oid = `sub_${mbId}_${Date.now()}`
      return await requestInicisPayment({
        oid, amount: price, goodname: `BODA ${planName} 구독`,
        buyername: customerName, buyertel: customerPhone, buyeremail: customerEmail,
        merchantData: { type: 'subscription', mbId, planId, planName, price, interval }
      })
    }
    provide('requestBillingKey', requestBillingKey)

    // 구독 해지
    async function cancelBillingSubscription(mbId) {
      try {
        await sql_query(`
          UPDATE subscriptions SET status = 'cancelled', cancelled_at = NOW()
          WHERE mb_id = '${mbId}' AND status = 'active'
        `)
        return { success: true }
      } catch (e) {
        console.error('❌ 구독 해지 실패:', e)
        return { success: false, message: e.message }
      }
    }
    provide('cancelBillingSubscription', cancelBillingSubscription)

    // 구독 정보 조회
    async function getSubscriptionInfo(mbId) {
      try {
        const rows = await sql_query(`
          SELECT s.*, p.name as plan_name
          FROM subscriptions s
          LEFT JOIN subscription_plans p ON s.plan_id = p.id
          WHERE s.mb_id = '${mbId}' AND s.status = 'active'
          ORDER BY s.created_at DESC LIMIT 1
        `)
        return Array.isArray(rows) && rows.length ? rows[0] : null
      } catch (e) {
        console.warn('구독 정보 조회 실패:', e)
        return null
      }
    }
    provide('getSubscriptionInfo', getSubscriptionInfo)

    // 결제 내역 조회
    async function getPaymentHistory(mbId) {
      try {
        const rows = await sql_query(`
          SELECT * FROM payment_history
          WHERE mb_id = '${mbId}'
          ORDER BY paid_at DESC
          LIMIT 20
        `)
        return Array.isArray(rows) ? rows : []
      } catch (e) {
        console.warn('결제 내역 조회 실패:', e)
        return []
      }
    }
    provide('getPaymentHistory', getPaymentHistory)

    // 토큰 충전 (이니시스 단건결제 → 서버에서 포인트 적립)
    async function purchaseTokens({ amount, tokenCount, customerName, customerEmail, customerPhone }) {
      const mbId = getMbid()
      if (!mbId) return { success: false, message: '로그인 필요' }
      const oid = `token_${mbId}_${Date.now()}`
      return await requestInicisPayment({
        oid, amount, goodname: `BODA 토큰 ${tokenCount}개`,
        buyername: customerName, buyertel: customerPhone, buyeremail: customerEmail,
        merchantData: { type: 'token_charge', mbId, tokenCount, amount }
      })
    }
    provide('purchaseTokens', purchaseTokens)


    /** RETURN */
    return { loading_visible, recommendToast, dismissRecommendToast, acceptRecommendTodos };
  },
};

</script>


<style>
@import "@/assets/css/global.css";

.recommend-toast-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 99999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 80px;
}
.recommend-toast {
  background: var(--color-bg, #1e1e2e);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 16px;
  width: 340px;
  max-width: 90vw;
  box-shadow: 0 12px 40px rgba(0,0,0,0.5);
  overflow: hidden;
}
.recommend-toast-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  font-weight: 700;
  font-size: 16px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.recommend-toast-close {
  background: none; border: none; color: var(--color-text-secondary, #888);
  font-size: 18px; cursor: pointer; padding: 0; line-height: 1;
}
.recommend-toast-list {
  list-style: none;
  margin: 0;
  padding: 12px 20px;
  max-height: 300px;
  overflow-y: auto;
}
.recommend-toast-list li {
  padding: 8px 0;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}
.recommend-toast-list li:last-child { border-bottom: none; }
.recommend-toast-list label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
}
.recommend-toast-list input[type="checkbox"] {
  width: 18px; height: 18px;
  accent-color: #3b82f6;
  flex-shrink: 0;
}
.recommend-toast-btns {
  display: flex;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid rgba(255,255,255,0.06);
}
.recommend-toast-btns button {
  flex: 1;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.1);
  background: transparent;
  color: var(--color-text, #fff);
  cursor: pointer;
  font-size: 14px;
}
.recommend-toast-btns button.main {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
  font-weight: 600;
}
.recommend-toast-btns button.main:hover {
  background: #2563eb;
}
</style>